import { toImageSrc } from "./svg-image-src";
import { parseImagenesField } from "../product/producto-form-utils";

export function buildProductGalleryImages(product) {
    if (!product) return [];

    const images = [];
    const seen = new Set();

    const pushImage = (value) => {
        const src = toImageSrc(value);
        if (!src || seen.has(src)) return;
        seen.add(src);
        images.push({ src });
    };

    pushImage(product.imagenPrincipal);

    parseImagenesField(product.imagenes).forEach(pushImage);

    return images;
}
